<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAlert } from 'dashboard/composables';
import SectionLayout from './SectionLayout.vue';
import Switch from 'next/switch/Switch.vue';

const { t } = useI18n();
const { currentAccount, updateAccount } = useAccount();
const isEnabled = ref(false);

watch(
  currentAccount,
  () => {
    isEnabled.value =
      !!currentAccount.value?.settings?.auto_assign_on_agent_reply;
  },
  { deep: true, immediate: true }
);

const toggleAutoAssign = async () => {
  try {
    await updateAccount({ auto_assign_on_agent_reply: isEnabled.value });
    useAlert(t('GENERAL_SETTINGS.AUTO_ASSIGN.SUCCESS'));
  } catch (error) {
    useAlert(t('GENERAL_SETTINGS.AUTO_ASSIGN.ERROR'));
  }
};
</script>

<template>
  <SectionLayout
    :title="t('GENERAL_SETTINGS.AUTO_ASSIGN.TITLE')"
    :description="t('GENERAL_SETTINGS.AUTO_ASSIGN.NOTE')"
    with-border
    hide-content
  >
    <template #headerActions>
      <div class="flex justify-end">
        <Switch v-model="isEnabled" @change="toggleAutoAssign" />
      </div>
    </template>
  </SectionLayout>
</template>
